const AchievementsSection = () => {
  const achievements = [
    {
      image: "https://public.readdy.ai/ai/img_res/9e15a27a06a78a7e3db62a3e129b591d.jpg",
      title: "국도 사면 보강 공사",
      location: "충청북도 음성군",
      product: "SC보강토 옹벽블록",
      height: "H=8.5m"
    },
    {
      image: "https://readdy.ai/api/search-image?query=river%20bank%20protection%20concrete%20block%20retaining%20wall%20vegetation%20green%20eco%20friendly%20waterway%20civil%20engineering%20completed%20project&width=800&height=600&seq=ach002&orientation=landscape",
      title: "하천 호안 정비 공사",
      location: "경기도 이천시",
      product: "SC식생 호안 축조블록",
      height: "L=320m"
    },
    {
      image: "https://readdy.ai/api/search-image?query=residential%20area%20retaining%20wall%20landscaping%20concrete%20decorative%20block%20wall%20completed%20construction%20neat%20clean%20professional%20finish&width=800&height=600&seq=ach003&orientation=landscape",
      title: "아파트 단지 조경 옹벽",
      location: "세종특별자치시",
      product: "레디락 옹벽 블록",
      height: "H=4.2m"
    }
  ];

  return (
    <section id="achievements" className="py-14 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        {/* Header */}
        <div className="mb-8 sm:mb-14 text-center">
          <span className="text-orange-500 text-xs sm:text-sm font-bold tracking-widest uppercase block mb-2">
            — ACHIEVEMENTS
          </span>
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-black text-gray-900">시공 실적</h2>
          <p className="text-gray-500 mt-2 text-sm sm:text-base max-w-sm mx-auto">
            전국 다양한 현장에서 검증된 시공 실적
          </p>
        </div>

        {/* Gallery - 모바일 2열 */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-6">
          {achievements.map((item) => (
            <div key={item.title} className="group rounded-xl sm:rounded-2xl overflow-hidden bg-gray-50 cursor-pointer">
              <div className="w-full h-28 sm:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-2.5 sm:p-5">
                {/* 모바일에서 배지 숨김 */}
                <div className="hidden sm:flex items-center gap-2 mb-2">
                  <span className="bg-orange-500/10 text-orange-600 text-xs font-semibold px-2.5 py-1 rounded-full">
                    {item.product}
                  </span>
                  <span className="bg-gray-200 text-gray-600 text-xs font-semibold px-2.5 py-1 rounded-full">
                    {item.height}
                  </span>
                </div>
                <h3 className="font-black text-gray-900 text-xs sm:text-lg leading-tight">{item.title}</h3>
                <div className="flex items-center gap-1 mt-1 text-gray-500 text-xs">
                  <i className="ri-map-pin-line text-orange-500 text-xs"></i>
                  <span className="truncate">{item.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Row - 모바일 4열 간소화 */}
        <div className="mt-8 sm:mt-16 grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-6">
          {[
            { value: "3,000+", label: "시공 실적", icon: "ri-building-2-line" },
            { value: "17개", label: "납품 지역", icon: "ri-map-2-line" },
            { value: "100%", label: "품질 보증", icon: "ri-shield-check-line" },
            { value: "48h", label: "납기 응대", icon: "ri-time-line" },
          ].map((stat) => (
            <div key={stat.label} className="bg-gray-50 rounded-xl sm:rounded-2xl p-3 sm:p-6 flex items-center gap-3">
              <div className="w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center bg-orange-500/10 rounded-lg sm:rounded-xl shrink-0">
                <i className={`${stat.icon} text-orange-500 text-base sm:text-xl`}></i>
              </div>
              <div>
                <div className="text-lg sm:text-2xl font-black text-gray-900">{stat.value}</div>
                <div className="text-gray-500 text-xs sm:text-sm">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;
